import React, { Component } from "react";
import StepperFormPreview from "./form-preview/StepperFormPreview";
import { Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

class FormPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenType: this.props.screenType || "mobile", // Default to 'mobile' if not provided
    };
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  handleCloseClick() {
    this.props.closePreviewDrawer();
  }

  render() {
    const { showPreview, formLayoutComponents } = this.props;

    return (
      <>
        <Drawer open={showPreview} anchor="right">
          <div
            style={{
              minWidth: "30vw",
              backgroundColor: "#f8f9fa",
              height: "100vh",
            }}
          >
            <div className="container">
              <div className="p-20">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <i
                      className="fas fa-chevron-right"
                      style={{ marginRight: "10px", cursor: "pointer" }}
                      onClick={this.handleCloseClick}
                    ></i>
                    <h4>Preview</h4>
                  </div>
                  <div>
                    <CloseIcon
                      style={{ marginRight: "10px", cursor: "pointer" }}
                      onClick={this.handleCloseClick}
                    />
                  </div>
                </div>
                <StepperFormPreview
                  screenType={this.state.screenType}
                  formLayoutComponents={formLayoutComponents}
                />
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}

export default FormPreview;
